import { Table as AntTable } from 'antd';
import React from 'react';
import { themeTableColumns } from '@/utils/themeTableColumns';

const ThemedTable = React.forwardRef<
  React.ComponentRef<typeof AntTable>,
  React.ComponentProps<typeof AntTable>
>((props, ref) => (
  <AntTable
    {...props}
    ref={ref}
    columns={props.columns ? themeTableColumns(props.columns) : undefined}
  />
));
ThemedTable.displayName = 'ThemedTable';
export default Object.assign(ThemedTable, AntTable) as typeof AntTable;
